import React from 'react';
import { FlexRow, Icon, IconSize, IconType, Tooltip } from '../../../ui-toolkit';
import { HeaderLabelTextPair } from './HeaderLabelTextPair';
import { TinyToolTipText } from './TinyToolTipText';
import { nbsp } from '../../../utilities/administration/magicStrings';
import { copyTextToClipboard } from '../../../utilities/shared/copyTextToClipboard';
import { toast } from 'react-toastify';
import { eTransactionCategory } from '../../../ui-toolkit/enums/eTransactionType';
import { FullName, isBuyerBorrower } from '../../../ui-toolkit/orders/interfaces/IParty';
import { IOrderDetailsData } from '../../../ui-toolkit/orders/interfaces/IOrderDetailsData';
import { bullet } from '../../../utilities/order/magicStrings';
import { DateFormat, getDateString } from '../../../ui-toolkit/utilities/getDateString';

export const HeaderInformationRow: React.FC<{ order: IOrderDetailsData }> = ({ order }) => {
  const partiesToShow = order.parties.filter(isBuyerBorrower).map(FullName).join(', ');

  return (
    <FlexRow>
      <HeaderLabelTextPair
        label={'Location'}
        text={`${order.property.city}, ${order.property.state}
              ${order.property.zip_code} ${bullet} ${order.property.countyName}`}
      />
      <HeaderLabelTextPair
        label={order.transaction.transaction_category === eTransactionCategory.Purchase ? 'Buyer' : 'Borrower'}
        text={partiesToShow}
      />

      <Tooltip
        tooltipContent={<TinyToolTipText message={'Click to copy full lender name'} />}
        trigger={'hover'}
        placement={'top'}
        offset={'.3rem'}
      >
        <FlexRow
          onClick={() =>
            copyTextToClipboard(order.lender.name ?? '').then(() => {
              toast('Copied!', { type: 'success' });
            })
          }
        >
          <HeaderLabelTextPair label={'Lender'} text={order.lender.name ?? ''} overflow={'ellipsis'} />
        </FlexRow>
      </Tooltip>

      <HeaderLabelTextPair label={'Client'} text={order.client.name} />
      {order.client.sprucePowered && (
        <Tooltip
          tooltipContent={<TinyToolTipText message={'SprucePowered Order'} />}
          placement={'right'}
          trigger={'hover'}
          offset={'.3rem'}
        >
          <Icon type={IconType.SprucePowered} size={IconSize.Small} />
        </Tooltip>
      )}

      {order.transaction.closing_date && (
        <HeaderLabelTextPair
          label={`Closing${nbsp}Date`}
          text={getDateString(DateFormat.short, order.transaction.closing_date)}
        />
      )}
    </FlexRow>
  );
};
